import { axios } from 'api'

const updateRedisOrder = (company: string, orderNumber: string) =>
  axios.put(`/redis/order`, {
    company,
    orderNumber
  })

const updateRedisTransferOrder = (company: string, orderNumber: string) =>
  axios.put(`/redis/transfer-order`, {
    company,
    orderNumber
  })

const addRedisTransferOrder = (company: string, orderData: any) =>
  axios.post(`/redis/save-transfer-order-to-redis`, { company, orderData })

export { updateRedisOrder, updateRedisTransferOrder, addRedisTransferOrder }
